var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentprocessing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 54.7324C16.1925 54.7324 5 43.5399 5 29.7324C5 15.9249 16.1925 4.73242 30 4.73242C43.8075 4.73242 55 15.9274 55 29.7324C55 43.5374 43.8075 54.7324 30 54.7324ZM30 17.2324C29.337 17.2324 28.7011 17.4958 28.2322 17.9647C27.7634 18.4335 27.5 19.0694 27.5 19.7324V32.2324C27.5 32.8955 27.7634 33.5313 28.2322 34.0002C28.7011 34.469 29.337 34.7324 30 34.7324C30.663 34.7324 31.2989 34.469 31.7678 34.0002C32.2366 33.5313 32.5 32.8955 32.5 32.2324V19.7324C32.5 19.0694 32.2366 18.4335 31.7678 17.9647C31.2989 17.4958 30.663 17.2324 30 17.2324ZM30 42.2324C30.663 42.2324 31.2989 41.969 31.7678 41.5002C32.2366 41.0313 32.5 40.3955 32.5 39.7324C32.5 39.0694 32.2366 38.4335 31.7678 37.9647C31.2989 37.4958 30.663 37.2324 30 37.2324C29.337 37.2324 28.7011 37.4958 28.2322 37.9647C27.7634 38.4335 27.5 39.0694 27.5 39.7324C27.5 40.3955 27.7634 41.0313 28.2322 41.5002C28.7011 41.969 29.337 42.2324 30 42.2324Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentprocessing);
export default __webpack_public_path__ + "static/media/paymentprocessing.982b040847a3a7f44ab7f0e7370aa977.svg";
export { ForwardRef as ReactComponent };